
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {sancionStore} from "@/store/sancionStore";
import {http} from "@/config/HttpClient";
import {DateTime} from "luxon";
import {MaterialService} from "@/services/MaterialService";
import {Alert} from "@/addons/Alert";
import InputUnsignedDecimal from "../../components/InputUnsignedDecimal.vue";
import InputUppercaseRequired from "../../components/InputUppercaseRequired.vue";
import InputUppercase from "../../components/InputUppercase.vue";
import {materialStore} from "@/store/materialStore";
import {IngresoService} from "@/services/IngresoService";
import {SalidaService} from "@/services/SalidaService";
import {ingresoStore} from "@/store/ingresoStore";
import {salidaStore} from "@/store/salidaStore";
import * as stream from "stream";
import valeSalidaNew from "@/views/valeSalida/ValeSalidaNew.vue";
import {UserAuth} from "@/models/UserAuth";
import router from "@/router";

@Component({
  name: "valeSalidaEdit",
  computed: {
    UserAuth() {
      return UserAuth
    }
  },
  components: {InputUnsignedDecimal, InputUppercaseRequired, InputUppercase},
})
export default class extends Vue {
  sancion = {
    codigo: '',
    meses_plazo: 1,

  }

  @Prop() isNew!: boolean
  @Prop() valeSalidaEdit!: any
  private iniciado = 'Iniciado'
  private materialStore = materialStore();
  private sancionStore = sancionStore();
  private salidaStore = salidaStore();
  private materialService = MaterialService.getInstance();
  private salidaService = SalidaService.getInstance();
  private fecha = DateTime.now().toFormat("yyyy-MM-dd");
  private headers = [
    {text: "Fecha", value: "fecha"},
    {text: "Acción", value: "accion"},
    {text: "Usuario", value: "user.email"}
  ];

  //search = null;
  validBuscar = false;
  valid = false;
  esEdiatr= false;
  selected_funcionario = null;
  txtBuscar = '';
  cantidad= 0.1;
  cantidad_entregada= 0.1;
  precio_unitario= 1;
  isEdit = false;
  txtNroTramite = '';
  isLoading = false;
  swEditar = true;
  txtSearch = "";
  txtFuncionario = "";
  valesalida = {
    id: this.$route.params.valeSalidaEdit.id,
    codigo: this.$route.params.valeSalidaEdit.codigo,
    fecha: this.$route.params.valeSalidaEdit.fecha,
    item: this.$route.params.valeSalidaEdit.item,
    nombre_completo: this.$route.params.valeSalidaEdit.nombre_completo,
    area_trabajo: this.$route.params.valeSalidaEdit.area_trabajo,
    tipo: this.$route.params.valeSalidaEdit.tipo,
    adquirido: this.$route.params.valeSalidaEdit.adquirido,
    destino: this.$route.params.valeSalidaEdit.destino,
    funcionario_id: this.$route.params.valeSalidaEdit.funcionario_id,
    es_impreso: this.$route.params.valeSalidaEdit.es_impreso
  };
  //clientes = [];
  materiales = [];
  funcionarios_all = [];

  public funcionario= {
    item: '',
    ci: '',
    nombre_completo: '',
    oficina: '',
    centro_costos: ''
  };

  cliente_seleccionado = null;
  private cuenta = null;

  //private sancion = [];

  //private sancion = null;

  $refs!: {
    form: HTMLFormElement,
    txtCuenta: HTMLInputElement,
    montoRec: HTMLInputElement,
  };

  mounted(){
    this.getNuevoCodigoVale();
    this.getCentroCostos();
    this.salidaStore.newValeSalida = [];
    this.showMaterialesPrestamo()
  }

  get valeSalidaNew(): any[] {
    return this.salidaStore.newValeSalida;
  }
  get centroCostos(): any {
    return this.salidaStore.centroCostos;
  }
  getCentroCostos() {
    this.salidaService.getCentroCostos();
  }
  get valeSalidaMaterial(): any[] {
    return this.salidaStore.valeSalidaMaterial;
  }

  get nuevoValeSalida(): any[] {
    return this.salidaStore.newValeSalida;
  }

  getFuncionarios(value:string){
    this.loading
    this.salidaService.getFuncionarios(value)
  }

  get funcionarios(): any {
    return this.salidaStore.funcionarios;
  }

  seleccionFuncionario(){
    if(this.selected_funcionario !== null){
      this.valesalida.item = this.selected_funcionario.item;
      this.valesalida.nombre_completo = this.selected_funcionario.nombre_completo;
      this.valesalida.area_trabajo = this.selected_funcionario.area_trabajo;
      this.valesalida.funcionario_id = this.selected_funcionario.id;
      this.valesalida.area_trabajo = this.selected_funcionario.oficina;
      this.funcionario= {
        item: this.selected_funcionario.item,
        ci: this.selected_funcionario.ci,
        nombre_completo: this.selected_funcionario.nombre_completo,
        oficina: this.selected_funcionario.oficina,
        centro_costos: this.selected_funcionario.centro_costos,
        centro_costocompleto: this.selected_funcionario.centro_costocompleto

      }
    }else
      this.limpiar()

  }

  limpiar() {
    this.funcionario = {
      item: '',
      ci: '',
      nombre_completo: '',
      centro_costos: ''
    }
  }


  get loading(): boolean {
    return this.materialStore.loading;
  }


  get nuevoCodigoVale(): string {
    return this.salidaStore.nuevoCodigoPrestamo;
  }

  getNuevoCodigoVale(){
    this.salidaService.getNuevoCodigoPrestamo()
  }

  getMateriales(value:string) {
    this.loading;
    this.materialService.getMateriales(value);
  }

  @Watch('txtFuncionario')
  searchFuncionario(value: string) {
    if(value != null && value.length > 1){
      this.$nextTick().then( () => {
        this.getFuncionarios(value);
      })

      this.funcionarios_all = this.salidaStore.funcionarios;

    }
  }

  @Watch('txtSearch')
  search(value: string) {
    if (value != null && value.length > 2) {
      this.$nextTick().then(() => {
        this.getMateriales(value);
      })
    }
  }
  guardar(){
    if (!this.$refs.form.validate()) {
      return;
    }
    Alert.confirm(`Actualizar en el Prestamo: <br>
                    ${this.valesalida.codigo}`
    ).then(res => {
      if (res.isConfirmed) {
          const data = {valeSalida: this.valesalida, valeSalidaId: this.valesalida.id}
          this.salidaService.updateValeSalida(data);

        this.$emit('listar')
      }
    })
  }

  guardarCodigoDevolucion(){
    if (!this.$refs.form.validate()) {
      return;
    }
    Alert.confirm(`Guardar el numero de presupuesto en el Prestamo: <br>
                    ${this.valesalida.numero_presupuesto}`
    ).then(res => {
      if (res.isConfirmed) {
        const data = {valeSalida: this.valesalida, valeSalidaId: this.valesalida.id}
        this.salidaService.saveNumeroPresupuesto(data);

        this.$emit('listar')
      }
    })
  }
  addMaterialValeSalida(codigo: string) {
    if ((this.cantidad > 0 && this.cantidad_entregada > 0 && this.precio_unitario > 0 ) && (this.cantidad >= this.cantidad_entregada)) {
      const data = {
        codigo: codigo,
        cantidad: this.cantidad,
        cantidad_entregada: this.cantidad_entregada,
        precio_unitario: this.precio_unitario,
        ingreso: this.valesalida.codigo,
        ingreso_id: this.valesalida.id
      }
      this.salidaService.addMaterialValeSalida(data);
      this.cantidad = 0.1;
      this.cantidad_entregada = 0.1;
      this.precio_unitario = 1;
      this.materialStore.materiales = [];
    } else {
      Alert.error('La cantidad debe ser mayor a 0, la cantidad debe ser mayor o igual a la cantidad entregada')
      return false
    }
  }
  deleteMaterial(id:number){
    const data = {
      id: id,
      valeSalida: this.valesalida.codigo
    }
    this.salidaService.deleteMaterialValeSalida(data);
  }

  deleteMaterialesIngreso(){
    const data = {
      valeSalida: this.valesalida.codigo
    }
    this.salidaService.deleteMaterialesValeSalida(data);
  }


  imprimir(id:number){
    if (id === undefined){
      Alert.error('Primero guarde el vale de salida')
      return false
    }
      this.salidaService.imprimirValeSalida(id);
    router.push({name: 'valesalidas'})

  }

  showMaterialesPrestamo(){
    const data = {
      prestamoId: this.valesalida.id,
    }
    this.salidaService.showMaterialesPrestamo(data);
  }

}
